import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-status-summary',
  templateUrl: './status-summary.component.html',
  styleUrls: ['./status-summary.component.scss'],
  imports: [AsyncPipe],
})
export class StatusSummaryComponent implements OnInit {
  @Input() available = 0;
  @Input() notAvailable = 0;
  @Input() outOfOffice = 0;

  currentDate$: Observable<string>;

  constructor() {
    console.log('app status summary constructor');
  }

  ngOnInit() {
    console.log('app status summary init');
    this.currentDate$ = new Observable<string>((observer) => {
      setInterval(() => observer.next(this.formatLongDateTime(new Date())), 1000);
    });
  }

  private formatLongDateTime(date: Date): string {
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const weekday = weekdays[date.getDay()];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    const hour24 = date.getHours();
    const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
    const minute = `${date.getMinutes()}`.padStart(2, '0');
    const meridiem = hour24 >= 12 ? 'PM' : 'AM';

    return `${weekday}, ${month} ${day}, ${year} ${hour12}:${minute} ${meridiem}`;
  }
}
